/**
 * @desc 关闭事件
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** id */
  id: number;
}

export function request(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/wap/event/{id}/close',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/wap/event/{id}/close',

    params,
  });
}
